/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/atoms/heading/css/heading';
import '@swisslife/patterns-base/src/atoms/text/css/text';
import './page-abstract.scss';
import './modifier/hero.scss';
